<h2 class="fw:regular c:blue-700 m-8:t m-16:b md:m-48:t md:m-24:b">Versicherte Geräte</h2>
<div class="widget-list">
    @for (tablet of tablets(); track tablet.id) {
        <app-tablet-plus-insurance-widget-detail
            [tablet]="tablet"
            (onSubmit)="updateTabletInformation(tablet.id, $event)"
            [submitting]="submitting()"
        />
    }
</div>
